import { render, staticRenderFns } from "./RewardForm.vue?vue&type=template&id=5a7861d4&"
import script from "./RewardForm.vue?vue&type=script&lang=js&"
export * from "./RewardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports